var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 237,
    viewBox: "0 0 200 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.234 62.0898C163.411 62.0898 178.329 73.9109 182.255 90.6328L198.829 161.226C201.776 173.777 192.251 185.797 179.358 185.797H101.374L92.1856 207.849L29.915 185.72C17.6852 184.655 9.11571 172.72 12.3852 160.591L32.9557 84.2816C36.4854 71.1876 48.3604 62.0898 61.9217 62.0898H146.234Z",
    fill: "#1F2E3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.394 175.45L91.5296 177.686L102.863 190.979L116.81 183.569C116.81 183.569 120.902 185.66 121.343 185.93C123.418 187.198 125.559 187.425 127.458 187.153C130.227 186.757 130.171 183.409 127.768 181.976L121.265 178.098C117.395 175.791 112.86 174.858 108.394 175.45Z",
    fill: "#FFDCD5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.255,
    y: 165.879,
    width: 50.0137,
    height: 5.2646,
    transform: "rotate(55.0435 110.255 165.879)",
    fill: "#3A7EFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.748 180.122L135.247 190.285C137.145 190.728 138.325 192.627 137.881 194.525C137.438 196.423 135.54 197.602 133.641 197.159L90.1421 186.996L91.748 180.122Z",
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9307 184.619L126.886 197.111C128.881 197.804 129.936 199.983 129.243 201.978C128.55 203.973 126.371 205.028 124.376 204.335L88.421 191.843L90.9307 184.619Z",
    fill: "#FFDCD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2393 191.779L121.614 203.375C123.455 204.015 124.429 206.026 123.789 207.867C123.149 209.708 121.138 210.682 119.297 210.043L85.9226 198.447L88.2393 191.779Z",
    fill: "#FFDCD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6553 198.353L117.571 209.441C119.412 210.081 120.386 212.092 119.746 213.933C119.106 215.775 117.095 216.749 115.254 216.109L83.3386 205.02L85.6553 198.353Z",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2451,
    y: 178.014,
    width: 35.6856,
    height: 13.5555,
    transform: "rotate(18.7433 89.2451 178.014)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.941,
    height: 30.3606,
    transform: "matrix(-0.933912 -0.357504 -0.357504 0.933912 94.9414 176.952)",
    fill: "#1F2E3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.466 212.263L134.591 209.889L138.91 206.87L139.466 212.263Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0981 23.656C66.2746 11.5595 75.6414 0.674805 87.8747 0.674805H124.06C136.285 0.674805 145.649 11.5453 143.84 23.6354L138.118 61.864C137.018 69.2089 130.71 74.6436 123.283 74.6436H88.6925C81.2717 74.6436 74.9663 69.2174 73.8601 61.8795L68.0981 23.656Z",
    fill: "#FFDCD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3395 59.6022C94.7134 59.4654 95.9381 60.4683 96.0749 61.8422L96.618 67.2964C96.7548 68.6703 95.7519 69.895 94.378 70.0318C93.0041 70.1686 91.7794 69.1657 91.6426 67.7918L91.0995 62.3376C90.9627 60.9637 91.9655 59.739 93.3395 59.6022Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.12 59.6022C117.746 59.4654 116.521 60.4683 116.384 61.8422L115.841 67.2964C115.704 68.6703 116.707 69.895 118.081 70.0318C119.455 70.1686 120.68 69.1657 120.816 67.7918L121.36 62.3376C121.496 60.9637 120.493 59.739 119.12 59.6022Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8743 0.674805C75.641 0.674805 66.2742 11.5595 68.0977 23.656L73.5505 59.8285L119.88 46.4747L139.245 54.3291L143.839 23.6354C145.649 11.5453 136.285 0.674805 124.06 0.674805H87.8743Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1015,
    cy: 187.957,
    r: 3.33784,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9746,
    cy: 193.188,
    r: 3.33784,
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.526 115.288L90.188 74.6218L120.864 74.6218L105.526 115.288Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.424 102.303L106.417 80.6606L110.185 74.6221L102.043 74.6221L105.81 80.6593L101.416 104.39L105.527 115.288L110.424 102.303Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceBody2);
export default __webpack_public_path__ + "static/media/IcOpinionServiceBody2.6bee171359b88011530148d27aaa53e1.svg";
export { ForwardRef as ReactComponent };